<template>
  <span>
    <v-app style="overflow-x: hidden !important;" class="overflow-hidden">
      <Navbar/>
      <v-content class="white">
        <transition :name="transitionName"> 
          <router-view
            @snackbarNotification="getSnack"
          ></router-view>
        </transition>
      </v-content>
      <v-snackbar v-model="snackbar" :color="type" :timeout="snackTimeout" bottom>
        <span :class="`${ arabic ? 'arFont' : '' }`">{{ snackbarContent }}</span>
        <v-btn color="white" dark text small @click="snackbar = false">
          <v-icon size="12">close</v-icon>
        </v-btn>
      </v-snackbar>
      <v-layout row justify-center>
        <v-dialog v-model="dialog" overlay-opacity="80" overlay-color="rgb(0 0 0 / 86%)" retain-focus persistent max-width="500">
          <v-card color="primary" dark :loading="loading">
            <v-card-title class="headline white--text">{{i18n.pleaseEnterPin}}</v-card-title>
            <v-card-text>
              <v-text-field
                :name="pinname"
                :id="pinname"
                :label="i18n.pin"
                solo
                :loading="loading"
                autofocus
                autocomplete="disabled"
                :append-icon="pinv ? 'visibility' : 'visibility_off'"
                @click:append="pinv = !pinv"
                v-model="pin"
                @keydown.enter="checkPin()"
                :type="pinv ? 'text' : fieldTypes.password"
                @focus="fieldTypes.password = 'text'"
                @blur="fieldTypes.password = 'password'"
                @keypress="isNumber($event)"
              ></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="success" :loading="loading" text @click.native="checkPin()">continue</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-app>
  </span>
</template>

<script>
import Navbar from './components/Navbar'
import axios from 'axios';
import { getRandomInt, randomString, getCDate, check, sleep } from '@/customFunction';
const headers = {'Accept': 'application/json'};

export default {
  components: { Navbar },
  name: 'App',
  data () {
    return {
      persistent: false,
      loading:false,
      transitionName:null,
      snackbar:false,
      snackbarContent:'',
      type:null,
      resettimeout: 30 * 60,
      timeout:this.resettimeout,
      timeoutInterval:null,
      pin:null,
      pinv:false,
      dialog:false,
      pinname:null,
      fieldTypes:{
        password:'text',
      }
    }
  },
  methods: {
    isNumber(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode != 46 && charCode != 45 && charCode != 46 &&
      !(charCode >= 48 && charCode <= 57)) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    getName() {
      return this.pinname = randomString(28, '#Aa')
    },
    setCookie(name, value, days) {
      var expires = "";
      var maxAge = "";
      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
        maxAge = "; max-age=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "") + expires + "; path=/";
    },
    getCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    },
    eraseCookie(name) {   
      document.cookie = name+'=; Max-Age=-99999999;';  
    },
    getSnack (text, type, persistent = false) {
      this.snackbar = true
      this.snackbarContent = text
      this.type = type
      this.persistent = persistent
    },
    showSnackbar (text, type) {
      this.$emit('snackbarNotification', text, type)
    },
    goTo(path) {
      this.$router.push(path).catch(x=>{})
    },
    async loadScrollStyle(theme){
      let b = `
        ::-webkit-scrollbar-track {
          -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.22);
            background-color: ${theme.secondary};
        }

        ::-webkit-scrollbar {
          width: 5px;
          background-color: ${theme.primary};
        }

        ::-webkit-scrollbar-thumb {
          background-color: ${theme.primary};
          border-radius:  0 0 20px 20px; 
        }`
        let a = document.createElement('style')
        a.innerHTML = b
        document.head.append(a)
    },
    getNotifications(){
      // this.$store.dispatch('onlineCheck')
      // // this.$store.dispatch('getNotifications')
      // setInterval(x=>{
      //   if(this.$store.state.centralLogin) {
      //     this.$store.dispatch('onlineCheck')
      //     // this.$store.dispatch('getNotifications')
      //   }
      // }, 10000)
      // setInterval(x=>{
      //   if(this.$store.state.centralLogin) {
      //     this.$store.state.user = this.$store.dispatch('getUser')
      //   }
      // }, 20 * 60 * 10000)
    },
    async checkState(){
      return new Promise(async (res, rej)=>{
        // Don't redirect if on the auth callback route
        if (this.$route.name === 'socialite_auth_callback') {
          console.log('On auth callback route, skipping redirect');
          return res(true);
        }
        
        if(this.getCookie('_MJC')) {
          this.$store.state.access_token = this.getCookie('_MJC')
          let a = await this.$store.dispatch('getUser')
          console.log('app check status', a)
          if(!a || a.error) {
            this.goTo('/login')
            this.setCookie('_ATO._PIM', false)
            console.log(a)
            res(false)
          } else {
            this.$store.state.user = a
            this.$store.state.centralLogin = true
            if(a.role == 'admin')  {
              this.goTo('/leads')
            } else if(a.role == 'superadmin')  {
              this.goTo('/campaigns')
            } else if(a.role.includes('de_'))  {
              this.goTo('/bw-campaigns')
            } else {
              this.goTo('/leads')
            }
            this.getNotifications()
            res(true)
          }
        } else {
          this.goTo('/login')
          res(false)
        }
      })
    },
    storeLast(){
      this.$store.state.last_click = new Date().getTime()
    },
    async checkPin() {
      // NEED EMP PIN TO COMPAIR
      this.loading = true
      if(this.pin) {
        let a = await axios.post(`${this.api}/users/pin`, {pin:this.pin}, {headers}).then(x=>x.data)
        if(a.status) {
          this.resolveChallangePin()
          this.loading = false
        } else {
          this.loading = false
          this.getSnack(`Wrong Pin`, 'error')
        }
      } else {
        this.getSnack(`Wrong Pin`, 'error')
      }
    },
    resolveChallangePin(){
      this.dialog = false
      this.pin = null
      this.setCookie('_ATO._PIM', false)
      this.startTimeOut()
    },
    challangePin(){
      clearInterval(this.timeoutInterval)
      console.log('ENTER PIN')
      this.setCookie('_ATO._PIM', true)
      this.getName()
      this.dialog = true
    },
    clearTimeOut(){
      this.resetTimeout()
      clearInterval(this.timeoutInterval)
      var events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'];
      events.forEach((name) => {
        document.removeEventListener(name, this.resetTimeout, true)
        document.removeEventListener(name, this.storeLast, true)
      });
    },
    startTimeOut(reload){
      this.resetTimeout()
      if(reload && this.getCookie('_ATO._PIM')) {
        this.timeout = 0
      }
      this.registerListereners()
      this.timeoutInterval = setInterval(x=>{
        if(this.timeout > 0 ){
          this.timeout--
          if(this.timeout == (0.3 * this.resettimeout)){
            this.getSnack(`Idle for ${this.timeout / 60 } minutes`, 'error')
          }
        } else {
          this.challangePin()
        }
      }, 1000)
    },
    async resetTimeout(){
      if(this.timeout < (0.10 * this.resettimeout) && this.timeoutInterval) {
        this.getSnack(`Welcome back`, 'success')
      }
      this.timeout = this.resettimeout * 1
    },
    registerListereners(){
      var events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'];
      events.forEach((name) => {
        document.addEventListener(name, this.resetTimeout, true); 
        if(name == 'mousedown' || name == 'keypress') {
          document.addEventListener(name, this.storeLast, true); 
        }
      });
    },
  }, 
  computed: {
    snackTimeout() {
      return !this.persistent ? 4000 : 0
    },
    api(){
      return this.$store.state.settings.apiBase
    },
    getLanguage(){
      if(this.$store.state.language == 'ar') {
        this.$vuetify.rtl = true
      }
      return this.$store.state.language
    },
    site(){
      if(this.$store.state.site) {
        let site = this.$store.state.site
        this.$vuetify.theme.currentTheme.primary = site.theme.light.primary
        this.$vuetify.theme.currentTheme.secondary = site.theme.light.secondary
        this.$vuetify.theme.currentTheme.accent = site.theme.light.accent
        this.$vuetify.theme.currentTheme.error = site.theme.light.error
        this.$vuetify.theme.currentTheme.info = site.theme.light.info
        this.$vuetify.theme.currentTheme.success = site.theme.light.success
        this.$vuetify.theme.currentTheme.warrning = site.theme.light.warrning
        this.loadScrollStyle(site.theme.light)
        return site
      } else {
        return {}
      }
    },
    globalLoading(){
      return this.$store.state.globalLoading
    },
    isLogin() {
      return this.$store.state.centralLogin
    },
    language(){
      return this.$store.state.language
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
  },
  watch: {
    isLogin(login){
      // Don't redirect if on the auth callback route
      if (this.$route.name === 'socialite_auth_callback') {
        console.log('On auth callback route, skipping login redirect');
        return;
      }
      
      if(login && this.$store.state.user) {
        if(this.$store.state.user.role == 'admin')  {
          this.goTo('/leads')
        } else if(this.$store.state.user.role == 'superadmin')  {
          this.goTo('/campaigns')
        } else if(this.$store.state.user.role.includes('de_'))  {
          this.goTo('/bw-campaigns')
        } else {
          this.goTo('/leads')
        }
      } else {
        this.setCookie('_ATO._PIM', false)
        // Only redirect if not already on login page
        if (this.$route.name !== 'login') {
          this.goTo('/login')
        }
      }
    },
    getLanguage(){},
    site(){},
    $route (to, from){
      console.log(to);
      let path = to.path
      let user = {...this.$store.state.user}
      let role = user.role
      
      const toDepth = to.path.split('/').length
      const fromDepth = from.path.split('/').length
      this.transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left'
    },
  },
  async created() {
    var w = window.location.origin
    var base_url = w.includes('localhost') || w.includes('firebase') || w.includes('web.app') ? 'https://aramccocrm.com' : window.location.origin
    var base_url_second = w.includes('localhost') || w.includes('firebase') || w.includes('web.app') ? 'https://aramcogermany.com' : window.location.origin
    console.log(base_url)
    this.$store.dispatch('setSettingsBase', {base:base_url, baseSecond:base_url_second})
    let a = await this.checkState()
    if(a){
      await this.$store.dispatch('loadSettings')
    }
    this.startTimeOut(true)

    window.addEventListener('online', () => {
      this.$store.commit('setOnline', 1)
      this.getSnack("Connection restored.", 'success')
    });

    window.addEventListener('offline', () => {
      this.$store.commit('setOnline', 0)
      this.getSnack("Connection lost. You are currently offline.", 'error', true)
    });

    if (navigator.connection) {
      navigator.connection.addEventListener('change', () => {
        const connectionSpeed = navigator.connection.downlink;
      
        if (connectionSpeed < 0.5) this.getSnack('You have a slow internet connection', 'orange', true);
      });
    }

  },
  async mounted(){
  },
  destroyed(){
  }
}
</script>
<style>
/*  */
.RTL {
  direction: rtl !important;
  
}
.arFont {
  font-family: 'Cairo', sans-serif !important;
  letter-spacing: unset !important;
}
.enFont {
  font-family: 'Poppins', sans-serif;
}
.arTitle {
  font-family: 'Cairo', sans-serif !important;
  letter-spacing: unset !important;
  font-size: 1.25rem!important;
  font-weight: 500;
  letter-spacing: .0125em!important;
}
</style>
